import { takeEvery, call, put } from 'redux-saga/effects';
import { apiGet, apiPost } from '../core/dapi';
import { getLocationPaperworkFieldsUrl } from '../core/dapi/paperwork';
import {
  locationPaperworkFieldsReceived,
  locationPaperworkFieldsError,
  initializingData,
  resetPaperworkState,
  isSubmittingPaperworkPage,
} from '../ducks/paperwork';
import { getPublicBookingByIdUrl } from '../core/dapi/waitList';
import { getPaperworkResponsesUrl } from '../core/dapi/paperworkResponses';
import { getLocationUrl } from '../core/dapi/location';
import { setPastBooking } from '../actions/pastBookings';
import { receiveLocation } from '../actions/location';
import { PaperworkTypes } from '../constants';

export class PaperworkSagas {
  static INITIALIZE_PAPERWORK_DATA = 'saga/INITIALIZE_PAPERWORK_DATA';
  static SUBMIT_PAPERWORK_PAGE = 'saga/SUBMIT_PAPERWORK_PAGE';
}

function* initializePaperworkData({ bookingId }) {
  try {
    yield put(resetPaperworkState());
    yield put(initializingData());
    const publicBookingUrl = getPublicBookingByIdUrl(bookingId);
    const publicBookingResponse = yield call(apiGet, publicBookingUrl);
    yield put(setPastBooking(publicBookingResponse));

    const locationId = publicBookingResponse.location_id;

    const locationUrl = getLocationUrl(locationId);
    const locationResponse = yield call(apiGet, locationUrl);
    yield put(receiveLocation(locationResponse));

    const locationPaperworkFieldsUrl = getLocationPaperworkFieldsUrl(
      locationId,
      PaperworkTypes.REGISTRATION
    );
    const locationPaperworkResponse = yield call(apiGet, locationPaperworkFieldsUrl);
    yield put(locationPaperworkFieldsReceived(locationPaperworkResponse));
  } catch (e) {
    console.error(e);
    yield put(locationPaperworkFieldsError(e));
  }
}

function* submitPaperworkPage({ formData, onSuccess, onError }) {
  yield put(isSubmittingPaperworkPage(true));
  try {
    yield call(apiPost, getPaperworkResponsesUrl(), formData);
    onSuccess();
  } catch (e) {
    onError();
  } finally {
    yield put(isSubmittingPaperworkPage(false));
  }
}

function* rootSaga() {
  yield takeEvery(PaperworkSagas.INITIALIZE_PAPERWORK_DATA, initializePaperworkData);
  yield takeEvery(PaperworkSagas.SUBMIT_PAPERWORK_PAGE, submitPaperworkPage);
}

export { rootSaga as default };
